import { Bookmark, Fullscreen, Heart, Phone } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { CustomModal } from '../component/ReusableComponents';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { useNavigate, Link } from 'react-router-dom'

const BusinessCard = ({ data, onShowDetails, index }) => {
  useEffect(() => {
  }, []);
  const navigate = useNavigate()

  const handleVendorDetails = () => {
    navigate(`/vendor/details/${data.id}`)
  }
  const delay = 500 * index;
  return (
    <div className="business-card"  data-aos-delay={delay}>
      <Link to={`/vendor/details/${data.id}`}>
        <div className="business-card-image">
          <img src={data.main_banner_image} alt={`${data.business_name} card`} />
        </div>
        <div className="business-card-details">
          <div className="business-porfile-image">
            <img src={data.banner_image} alt={`${data.business_name} profile`} />
          </div>
          <div className="">
            <div className="business-details">
              <h5 className='font-bold pb-1 underline mt-4 '>{data.business_name}</h5>

              {data.short_description && data.short_description.length > 39 ? (
                <Tippy
                  content={
                    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                      {data.short_description}
                    </div>
                  }
                  placement="top"
                >
                  <p className='pb-2 business-card-short-description'>
                    {data.short_description}
                  </p>
                </Tippy>
              ) : (
                <p className='pb-2 business-card-short-description'>
                  {data.short_description ? data.short_description : "N/A"}
                </p>
              )}


              <Tippy content="Make a Call" placement="bottom" >
                <a href={`tel:${data.contact_no || "N/A"} `} className="w-1/2 custom-theme-link-color text-sm text-gray-600 flex items-center hover:text-purple-500">
                  <Phone className="w-4 h-4 mr-2 theme-color " />{" "}
                  <span className="" >
                    {data.contact_no || "N/A"}
                  </span>
                </a>
              </Tippy >
              {/* <p className='pb-2'>
                {data.contact_no || "N/A"}
              </p> */}
            </div>
            {/* <div className="business-card-action-buttons">
              <Tippy content="View details">
                <span onClick={handleVendorDetails} style={{ cursor: 'pointer' }}>
                  <Fullscreen />
                </span>
              </Tippy>
            </div> */}
          </div>
        </div>
      </Link>
    </div>
  );
};

const BusinessCards = ({ data, title }) => {
  useEffect(() => {
  }, [])
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  const showDetails = (businessData) => {
    setSelectedBusiness(businessData);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBusiness(null);
  };

  return (
    <>
      <div className='container max-w-screen-xl mx-auto' >
        <div className="py-6">
          <div className="mx-auto px-4">
            <div className="text-center">
              <h6 className="section-title py-2"  data-aos-delay="200">{title}</h6>
            </div>
          </div>
        </div>
      </div>

      <div className="business-categories-wrapper w-full pb-6"  >
        <div className="container max-w-screen-xl mx-auto">
          <div className="flex">
            {data?.length > 0 ? (
              data.map((business, index) => (
                <BusinessCard
                  key={business.id}
                  data={business}
                  onShowDetails={showDetails}
                  index={index}

                />
              ))
            ) : (
              <p className=' text-center w-full theme-color font-bold text-xl py-6'>No vendors found</p>
            )}
          </div>
        </div>
      </div>

      <CustomModal width='70%' isOpen={isModalOpen} onClose={handleCloseModal}>
        {selectedBusiness && (
          <div className="p-4">
            <h2 className="text-xl font-bold mb-4">{selectedBusiness.business_name}</h2>

            <div className="business-details-content flex">
              <div className="mb-4 w-1/2 px-2">
                <img
                  src={selectedBusiness.main_banner_image}
                  alt={selectedBusiness.business_name}
                  className="w-full h-48 object-cover rounded"
                />
              </div>
              <div className="space-y-2 px-2 w-1/2">
                <p><strong>Contact No:</strong> {selectedBusiness.contact_no}</p>
                <p><strong>Verification Status:</strong> {selectedBusiness.verification_status ? "Verified" : "Pending"}</p>
              </div>
            </div>
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default BusinessCards;


// import { Bookmark, Fullscreen, Heart } from 'lucide-react'
// import React, { useState } from 'react'
// import { CustomModal } from '../component/ReusableComponents'
// import Tippy from '@tippyjs/react'
// import 'tippy.js/dist/tippy.css'

// // Sample data array - in real app, this would likely come from an API
// const businessCardsData = [
//   {
//     id: 1,
//     profileName: "Business One",
//     description: "Description for business one",
//     image: "/assets/home-grid/family-green-nature-together.jpg",
//     profileImage: "/assets/home-grid/deal.jpg",
//     details: {
//       address: "123 Main St, Phoenix, AZ",
//       phone: "(555) 123-4567",
//       website: "www.business1.com",
//       hours: "Mon-Fri: 9AM-5PM"
//     }
//   },
//   {
//     id: 2,
//     profileName: "Business Two",
//     description: "Description for business two",
//     image: "/assets/home-grid/family-green-nature-together.jpg",
//     profileImage: "/assets/home-grid/deal.jpg",
//     details: {
//       address: "456 Oak St, Scottsdale, AZ",
//       phone: "(555) 234-5678",
//       website: "www.business2.com",
//       hours: "Mon-Sat: 10AM-8PM"
//     }
//   },
//   {
//     id: 3,
//     profileName: "Business Three",
//     description: "Description for business three",
//     image: "/assets/home-grid/family-green-nature-together.jpg",
//     profileImage: "/assets/home-grid/deal.jpg",
//     details: {
//       address: "789 Pine St, Mesa, AZ",
//       phone: "(555) 345-6789",
//       website: "www.business3.com",
//       hours: "Mon-Sun: 8AM-9PM"
//     }
//   }
// ]

// const BusinessCard = ({ data, onShowDetails }) => {
//   console.log("data on businesscard", data);
//   return (
//     <div className="business-card">
//       <div className="business-card-image">
//         <img src={data.image} alt={`${data.profileName} card`} />
//       </div>
//       <div className="business-card-details">
//         <div className="business-porfile-image">
//           <img src={data.profileImage} alt={`${data.profileName} profile`} />
//         </div>
//         <div className="gumnaam">
//           <div className="business-details">
//             <h5 className='font-bold pb-1'>{data.profileName}</h5>
//             <p className='pb-2'>
//               {data.description}
//             </p>
//           </div>
//           <div className="business-card-action-buttons">
//             {/* <Tippy content="Save to bookmarks">
//               <span>
//                 <Bookmark />
//               </span>
//             </Tippy> */}
//             <Tippy content="View details">
//               <span onClick={() => onShowDetails(data)}>
//                 <Fullscreen />
//               </span>
//             </Tippy>
//             {/* <Tippy content="Add to favorites">
//               <span>
//                 <Heart />
//               </span>
//             </Tippy> */}
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// const BusinessCards = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false)
//   const [selectedBusiness, setSelectedBusiness] = useState(null)

//   const showDetails = (businessData) => {
//     setSelectedBusiness(businessData)
//     setIsModalOpen(true)
//   }

//   const handleCloseModal = () => {
//     setIsModalOpen(false)
//     setSelectedBusiness(null)
//   }

//   return (
//     <>
//       <div className='container max-w-screen-xl'>
//         <div className="py-6">
//           <div className="mx-auto px-4">
//             <div className="text-center">
//               <h6 className="section-title py-2">Discover Family Fun AZ 1</h6>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="business-categories-wrapper w-full pb-6">
//         <div className="container max-w-screen-xl mx-auto">
//           <div className="flex">
//             {businessCardsData.map(business => (
//               <BusinessCard
//                 key={business.id}
//                 data={business}
//                 onShowDetails={showDetails}
//               />
//             ))}
//           </div>
//         </div>
//       </div>

//       <CustomModal width='70%' isOpen={isModalOpen} onClose={handleCloseModal}>
//         {selectedBusiness && (
//           <div className="p-4">
//             <h2 className="text-xl font-bold mb-4">{selectedBusiness.profileName}</h2>

//             <div className="business-details-content flex">
//               <div className="mb-4 w-1/2 px-2">
//                 <img
//                   src={selectedBusiness.image}
//                   alt={selectedBusiness.profileName}
//                   className="w-full h-48 object-cover rounded"
//                 />
//               </div>
//               <div className="space-y-2 px-2 w-1/2">
//                 <p><strong>Address:</strong> {selectedBusiness.details.address}</p>
//                 <p><strong>Phone:</strong> {selectedBusiness.details.phone}</p>
//                 <p><strong>Website:</strong> {selectedBusiness.details.website}</p>
//                 <p><strong>Hours:</strong> {selectedBusiness.details.hours}</p>
//                 <p className="mt-4">{selectedBusiness.description}</p>
//               </div>
//             </div>
//           </div>
//         )}
//       </CustomModal >
//     </>
//   )
// }

// export default BusinessCards